import { CheckCircle, Download, Edit3, Lock, Share2, Star } from 'lucide-react';
import { FC } from 'react';
import FeatureCard from './FeatureCard';

const Features: FC = () => {
  const features = [
    {
      icon: <Edit3 className='h-6 w-6' />,
      title: 'Professional Templates',
      description: 'Start with industry-tested templates designed to pass ATS systems.',
      delay: '0.1s',
    },
    {
      icon: <Star className='h-6 w-6' />,
      title: 'Real-Time ATS Score',
      description: 'Know how your resume performs against ATS algorithms.',
      delay: '0.2s',
    },
    {
      icon: <Download className='h-6 w-6' />,
      title: 'Instant PDF Export',
      description: 'Download your resume with one click in multiple formats.',
      delay: '0.3s',
    },
    {
      icon: <CheckCircle className='h-6 w-6' />,
      title: 'AI-Powered Suggestions',
      description: 'Get smart recommendations tailored for each job application.',
      delay: '0.4s',
    },
    {
      icon: <Lock className='h-6 w-6' />,
      title: 'Privacy First',
      description: 'Your data stays secure with enterprise-grade encryption.',
      delay: '0.5s',
    },
    {
      icon: <Share2 className='h-6 w-6' />,
      title: 'Easy Sharing',
      description: 'Share your resume with recruiters via secure, trackable links.',
      delay: '0.9s',
    },
  ];

  return (
    <section id='features' className='py-20 z-20'>
      <div className='container mx-auto px-4'>
        <div className='text-center max-w-3xl mx-auto mb-20'>
          <div className='inline-flex items-center space-x-2 bg-primary/10 text-primary px-4 py-2 rounded-md text-sm font-medium mb-5'>
            <span>Why ResumeReady?</span>
          </div>
          <h2 className='text-3xl lg:text-4xl xl:text-5xl font-bold mb-6 text-white leading-tight'>
            Create a Resume That Gets You <span className='text-primary'>Hired</span>
          </h2>
          <p className='text-lg text-muted-foreground max-w-2xl mx-auto'>
            Our intelligent builder gives you the edge in today's competitive job market
            with features designed to help you stand out.
          </p>
        </div>

        <div className='grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto'>
          {features.map((feature) => (
            <FeatureCard
              key={feature.title}
              icon={feature.icon}
              title={feature.title}
              description={feature.description}
              delay={feature.delay}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
